import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

export interface CookieSettings {
  name: string;
  value: string;
  expires?: DateTime;
  secure?: boolean;
  session?: boolean;
  domain?: string;
  path?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  setCookie(settings: CookieSettings): void {
    let cookieString = `${encodeURIComponent(settings.name)}=${encodeURIComponent(settings.value)}`;

    if (settings.expires) {
      cookieString += `; expires=${settings.expires.toJSDate().toUTCString()}`;
    }

    if (settings.path) {
      cookieString += `; path=${settings.path}`;
    } else {
      cookieString += `; path=/`;
    }

    if (settings.domain) {
      cookieString += `; domain=${settings.domain}`;
    }

    if (settings.secure) {
      cookieString += `; secure`;
    }

    if (!settings.session) {
      cookieString += `; samesite=strict`;
    }

    document.cookie = cookieString;
  }

  getCookie(name: string): string | null {
    const nameEQ = encodeURIComponent(name) + '=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }

    return null;
  }

  deleteCookie(name: string, domain?: string, path?: string): void {
    let cookieString = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

    if (path) {
      cookieString += `; path=${path}`;
    } else {
      cookieString += `; path=/`;
    }

    if (domain) {
      cookieString += `; domain=${domain}`;
    }

    document.cookie = cookieString;
  }
}
